import { useTranslation } from 'react-i18next';

import { FlexContainer } from '../../../../styled';
import { StyledActionButton } from '../../styled';
import { SavingStatus } from '../../types';
import HelpAlert from '../HelpAlert/HelpAlert';
import SavingStatusAlert from './components/SavingStatusAlert/SavingStatusAlert';

export interface Props {
    fullWidthSelector: boolean;
    tabsRender: JSX.Element;
    savingStatus: SavingStatus;
    exportData: (type: 'csv' | 'pdf') => void;
    exportWholePdf: () => void;
    retrySave: () => void;
}

const Header = (props: Props) => {
    const { fullWidthSelector, tabsRender, savingStatus, exportData, exportWholePdf, retrySave } = props;

    const { t } = useTranslation();

    return (
        <>
            {fullWidthSelector && (
                <div style={{ marginBottom: '14px' }}>
                    {tabsRender}
                </div>
            )}

            <FlexContainer>
                {!fullWidthSelector && <>{tabsRender}</>}

                <div style={{ textAlign: fullWidthSelector ? 'center' : 'right', marginTop: '-6px' }}>
                    <StyledActionButton onClick={() => exportData('csv')} >
                        {t('pages.plastic_assessment.export_csv')}
                    </StyledActionButton>{' '}
                    <StyledActionButton onClick={() => exportData('pdf')} >
                        {t('pages.plastic_assessment.export_pdf')}
                    </StyledActionButton>{' '}
                    <StyledActionButton onClick={() => exportWholePdf()} >
                        {t('pages.plastic_assessment.export_whole_pdf')}
                    </StyledActionButton><br />

                </div>
            </FlexContainer>

            <FlexContainer>
                <div style={{ flex: 1 }} />

                <div style={{ flex: 3, marginLeft: '8px', marginRight: '8px' }}>
                    <HelpAlert />
                </div>

                <div style={{ flex: 1 }}>
                    <SavingStatusAlert savingStatus={savingStatus} retrySave={retrySave} />
                </div>
            </FlexContainer>
        </>
    );
};

export default Header;